import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { FeatureGuardMode, GuardedFeature } from '@recruitee/feature-guard';
import { IconName } from '@recruitee/user-interface';

@Component({
  selector: 'rt-redactor-inserts-dropdown-item',
  templateUrl: 'redactor-inserts-dropdown-item.component.html',
  styleUrls: ['./redactor-inserts-dropdown-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RedactorInsertsDropdownItemComponent {
  @Input() public iconName: IconName;
  @Input() public heading: string;
  @Input() public subheading: string;
  @Input() public selected: boolean;
  @Input() public featureGuard: GuardedFeature;
  @Input() public badgeText?: string;

  @Output() public stepInside: EventEmitter<MouseEvent> = new EventEmitter();

  public featureGuardMode: typeof FeatureGuardMode = FeatureGuardMode;
}
